import React, { useState } from 'react'
import { Trans, t } from '@lingui/macro'
import { Modal } from '../../../components/common/modal/Modal'
import { ButtonPrimary, ButtonClean } from 'front-end/src/components'
import Form, { FormRow } from '../../../components/common/form/Form'
import Input from '../../../components/common/form/input/Input'
import Label from '../../../components/common/form/label/Label'
import uniqueId from '../../../components/utils/uniqueId'

import { useMutation } from '@apollo/client'
import gql from 'graphql-tag'

interface IPathway {
  id: number
  title: string
}

interface IProps {
  onPathwayCreated: (pathway: IPathway) => void
  onCancel: () => void
}

const PATHWAY_CREATE_MUTATION = gql`
  mutation createPathway($title: String!) {
    admin {
      createPathway(data: { title: $title }) {
        id
        title
      }
    }
  }
`

const PathwayCreateModal = (props: IProps) => {
  const { onCancel, onPathwayCreated } = props

  const inputTitleId = uniqueId()
  const [title, setTitle] = useState('')
  const [pathwayCreate, { loading }] = useMutation<{
    admin: {
      createPathway: IPathway
    }
  }>(PATHWAY_CREATE_MUTATION)

  const onSubmit = async () => {
    const response = await pathwayCreate({ variables: { title } })
    if (!response || !response.data) {
      return null
    }
    onPathwayCreated(response.data.admin.createPathway)
  }

  return (
    <Modal
      header={t`Create a pathway`}
      // @ts-expect-error 9/11/2020
      onHide={null}
      onHidden={() => setTitle('')}
      controls={
        <>
          <ButtonClean onClick={onCancel}>
            <Trans>Cancel</Trans>
          </ButtonClean>
          <ButtonPrimary
            disabled={!title}
            onClick={onSubmit}
            isLoading={loading}
          >
            <Trans>Create</Trans>
          </ButtonPrimary>
        </>
      }
    >
      <Form onSubmit={onSubmit}>
        <FormRow>
          <Label htmlFor={inputTitleId}>
            <Trans>Pathway title</Trans>
          </Label>
          <Input
            autoFocus
            fullWidth
            id={inputTitleId}
            placeholder={t`My new pathway`}
            onChange={(val: string): void => {
              setTitle(val)
            }}
            value={title}
          />
        </FormRow>
      </Form>
    </Modal>
  )
}

export default PathwayCreateModal
